import React, { useContext, useState, useEffect,useCallback} from "react";
import Http from "../../../networkReq/http";
import {useParams} from "react-router-dom";
import Request from "../../../networkReq/request";
import { getToken, getCurrentUser } from 'utils/storage';
import Collected from "images/collected.png";
import CollectWork from "images/collectWork.png";
import "./index.scss";
import "../index.scss";
import {getDict} from "@/utils/storage";
import {
  Card,
  Pagination,
  Button,
  ConfigProvider,
  Input,
  Select,
  Form,
  Row,
  Col,
  message
} from "antd";

// {
//     name: "xxx职位",
//     area: "眉山市 东坡区",
//     companyName: "xxx公司",
//     isDelivery: false,
//     recruitmentNum: 100,
//     salary: "13-17k",
//     workYear: "3-5",
//     education: "本科",
//     type: "私营企业",
//     enterpriseNum: "100-499",
//     treatment: "通讯补贴，员工旅游，五险一金，定期体检，",
//     isCollection: false,
//   },

export default function JobDetail() {
  const [mapData,setMapData] = useState([])
  const [succeed, setSucceed] = useState(0);   //收藏
  const [succeedTwo, setSucceedTwo] = useState(0);   //收藏
  const routeParmas = useParams()
  const codeList =  getDict();

  const sendOneResume = (id)=>{
    Http.get(Request.sendOnesResume(), {id:id}, obj => {
      if(obj.code == 200){ 
        message.success('投递成功', 2);
        initialData()
      }else{
        // message.error('投递失败');
        message.error(obj.msg ? obj.msg :'投递失败')
      }
    });
  }
  const collects = useCallback((id,collect ) => {
    console.log("1212132")
    //收藏方法和取消收藏方法
    console.log("collectcollect",collect)
    if(collect == 0){
      Http.get(Request.collectList(), {id:id}, obj => {
        if(obj.code == 200){
          setSucceed(id)
          setSucceedTwo(collect)
          message.success('收藏成功', 2);
        }
      });
    }else{
      Http.get(Request.cancelCollectList(), {id:id}, obj => {
        if(obj.code == 200){
          setSucceed(id)
          setSucceedTwo(collect)
          message.success('取消成功',2);
        }
      });
    }
    
  }, []);
  const initialData = ()=>{
    let params = {
      id:routeParmas.id
    } 
    Http.get(Request.jobDetailsData(), {...params}, obj => {
      if(obj.code == 200){
        setMapData(obj.data)
      }
      
  });
  }
  useEffect(() => {
    initialData()
    
  }, [succeed,,succeedTwo]);

  return (
    <div className={"my_delivery_jobdetail_app"}>
      <section className={"job_item_header"}>
        <div className={"job_item_title"}>
          <div className={"job_item_left"}>
            <span
              className={"job_item_name"}>
                {mapData.job}
              </span>
            <span className={"job_item_area"}>{mapData.salary}</span>
          </div>
          <div>
          <Button 
            onClick={() => {collects(mapData.id,mapData.favoriteOrNot)}} 
            className={"job_item_button"}  
            value="large" 
            >
            {<img
            src={mapData.favoriteOrNot==1 ? Collected : CollectWork}
            alt=""
            style={{ marginBottom: 4,marginRight: 6 }}
          />}  {mapData.favoriteOrNot == 0 ? "收藏职位" : "已收藏"}</Button>
          <Button onClick={()=>sendOneResume(routeParmas.id)} className={"job_item_button"} disabled={mapData.resumeOrNot == 1 ? true : false}  type={mapData.resumeOrNot == 1 ? "dashed":"primary" }>{mapData.resumeOrNot == 1 ? "已投递":"投递简历"}</Button>
         
          </div>
        </div>
        <div className={"job_item_left"}>
          <span className={"job_item_treatment"}>{mapData.workArea}&nbsp;·&nbsp;{mapData.workExperience}&nbsp;·&nbsp;{mapData.degree===1?'大专':mapData.degree==2?'本科':mapData.degree==3?'研究生':''}&nbsp;·&nbsp;{mapData.jobReleaseTime}&nbsp;发布


          </span>
        </div>
      </section>
      {/* 岗位信息及要求 */}
      <section className="job_item_require_infos">
        <div className="job_item_require_detail">
          <div className="job_item_human_affairs">
            <div className="human_affairs_infos">
              <div className="human_affairs_name">{mapData.jobInformationContacts}</div>
              <div className="phone_job_deadline_time">
                <div className="human_affairs_phone">
                  联系电话：{mapData.jobInformationTel}
                </div>
                <div className="job_deadline_time">
                  招聘截止日期：{mapData.deadline}
                </div>
              </div>
            </div>
          </div>

          {/* 职位描述 */}
          <div className="job_describe_info">
            <div className="job_require_describes">福利待遇</div>
            <div className="job_footer_border"></div>
            <div className="job_p">{mapData.welfare}</div>

            <div className="job_describes">
              <div className="job_require_describes">职位描述</div>
              <div className="job_footer_border"></div>
              <div className="job_info_p">
                <div>
                  <span className="job_info_titles">招聘人数：</span>
                  <span className="job_info_require">{mapData.recruitsNumber}</span>
                </div>
                <div>
                  <span className="job_info_titles">到岗时间：</span>
                  <span className="job_info_require">{mapData.onDutyTime}</span>
                </div>
                <div>
                  <span className="job_info_titles">年龄要求：</span>
                  <span className="job_info_require">{mapData.ageRange}</span>
                </div>
                <div>
                  <span className="job_info_titles">性别要求：</span>
                  <span className="job_info_require">{mapData.genderAsk}</span>
                </div>
            </div>
              {/* <div className="job_info_titles">职位描述：</div> */}
              <div>
                {/* {jobDescribe.map((item, index) => {
                  const element = (
                    <div key={index}>
                      <span className="job_info_titles">{index + 1}、</span>
                      <span className="job_info_titles">{item}</span>
                    </div>
                  );
                  return element;
                })} */}
                {mapData.jobDescription}
              </div>
              <div className="job_info_titles">任职要求：</div>
              <div>

                {mapData.jobRequirements}
              </div>
              <div>
                  <span className="job_info_titles">工作地址：</span>
                  <span className="job_info_require">{mapData.workAddress}</span>
                </div>
            </div>
          </div>
        </div>
        <div className="job_item_Broken_info"></div>
        <div className="job_item_company_info">
          <div className="human_affairs_name">公司基本信息</div>
          <div className="job_footer_border"></div>
          <div className="job_item_company_name">{mapData.auditMechanismName}</div>
          <div>
            <span className="company_info_job_num_label">招聘人数：</span>
            <span className="company_info_job_num">{mapData.recruitsNumber}</span>
            {/* <span className="company_info_job_num_label">人</span> */}
          </div>
          <p className="job_item_company_describe">{mapData.auditMechanismIntroduce}</p>
        </div>
      </section>
    </div>
  );
}
